/* eslint-disable no-use-before-define */

/**
 * Load more overlay over existing pagnination setup.
 * Works by loading the next page unaltered but pulling the contents of external #js-listings
 * into current #js-listings
 */

function getExternalElement(url, ref, action, callback = function _callback() {}) {
    const XHRt = new XMLHttpRequest(); // new ajax
    XHRt.responseType = 'document'; // ajax2 context and onload() event
    XHRt.onload = function _onload() {
        document.querySelectorAll(`[${ref}]`).forEach((src) => {
            const to = document.querySelector(`[${ref}="${src.getAttribute(ref)}"]`);
            const from = XHRt.response.querySelector(`[${ref}="${src.getAttribute(ref)}"]`) || null;
            if (action === 'append') {
                if (from) to.innerHTML += from.innerHTML;
            } else if (action === 'replace') {
                if (from) to.outerHTML = from.outerHTML;
            }
        });

        callback();
    };
    XHRt.open('GET', url, true);
    XHRt.send();
    return XHRt;
}

function setBtn() {
    const loadMoreBtns = document.querySelectorAll('[data-js-listing-button], [data-listing-button-ref]');
    loadMoreBtns.forEach((loadMoreBtn) => {
        loadMoreBtn.removeEventListener('click', loadMore);
        loadMoreBtn.removeEventListener('touchstart', loadMore);
        loadMoreBtn.addEventListener('click', loadMore);
        loadMoreBtn.addEventListener('touchstart', loadMore);
    });
}

function loadMore(e) {
    e.stopPropagation();
    e.preventDefault();
    const loadMoreBtn = e.currentTarget;

    // append the contents of the next page into this
    getExternalElement(
        loadMoreBtn.getAttribute('data-href'),
        loadMoreBtn.getAttribute('data-listings-ref') || 'data-js-listings',
        'append',
        global.quietmark.revealer,
    );

    // replace the existing button with the next page's one
    getExternalElement(
        loadMoreBtn.getAttribute('data-href'),
        loadMoreBtn.getAttribute('data-listing-button-ref') || 'data-js-listing-button',
        'replace',
        // eslint-disable-next-line no-use-before-define
        () => {
            setBtn();
            window.dispatchEvent(new Event('resize'));
        },
    );
}

// init
setBtn();
